/*
 * @Author: RYL
 * @Description: 设备组态模块接口
 * @Date: 2021-01-22 16:20:12
 * @LastEditTime: 2021-01-22 17:36:32
 */
import http from '@/axios/http'

// 获取开通云监测功能的客户列表
export function getCustomerList(data) {
  return http({
    url:'/api2/customer/list',
    method: 'post',
    data,
  })
}
// 获取开通云监测功能的客户的用户列表
export function getUserList(cid) {
  return http({
    url:'/api2/customer/user/list',
    method: 'post',
    data: {
      cid,
    },
  })
}